import { GeoJSONSourceSpecification } from 'maplibre-gl'

export const emptyGeoJsonSource: GeoJSONSourceSpecification = {
  type: 'geojson',
  data: {
    type: 'FeatureCollection',
    features: [],
  },
}
